
import { Component, Vue } from "vue-property-decorator";
import { accountApi } from "../../services/api/account/account";
import { ValidateDocumentationQuery } from "../../services/api/models/ValidateDocumentationQuery.model";
import { ValidateCitizenCommand } from "../../services/api/models/ValidateCitizenCommand.model";
import { ValidatePassportCommand } from "../../services/api/models/ValidatePassportCommand.model";
import { RegisterCommand } from "../../services/api/models/RegisterCommand.model";
import { TrivialDto } from "../../services/api/models/TrivialDto.model";
import PanamaLayout from "../../layouts/PanamaLayout.vue";
import PhonePrefix from "../../components/PhonePrefix.vue";
import Nationality from "../../components/Nationality.vue";
import FaceDetector from "../../components/FaceDetector.vue";

@Component({
  components: { PhonePrefix, PanamaLayout, Nationality, FaceDetector },
})
export default class Register extends Vue {
  private isErrorMessageShow = false;
  private errorMessage = "";

  private showNationalityRequiredError = false;
  private showIdentificationRequiredError = false;
  private showPersonalInfoRequiredError = false;
  private isPersonalInfoFirstAttempt = false;

  private isIdentificationLoading = false;
  private isValidationLoading = false;
  private validationByCedula = false;
  private isPersonalInfoLoading = false;
  private isSavingProfile = false;

  private step = 1;

  private nationality = "";
  private idDocumentType = "";
  private idDocumentNumber = "";
  private givenName = "";
  private familyName = "";
  private birthDate = "";
  private email = "";
  private address = "";
  private sameEmailForNotifications = true;
  private notificationsEmail = "";
  private phonePrefix = "";
  private phoneNumber = "";
  private password = "";
  private repeatPassword = "";
  private pin = "";
  private repeatPin = "";
  private keyValid = "";

  private profilePicName = "";
  private profilePicBase64 = "";
  private cedulaPicName = "";
  private cedulaPicBase64 = "";
  private passportPicName = "";
  private passportPicBase64 = "";

  private trivial!: TrivialDto;
  private questionAnswersOne = "";
  private questionAnswersTwo = "";
  private questionAnswersThree = "";
  private questionAnswersFour = "";

  private showPassword = false;
  private showPin = false;

  private isCapture = false;
  private isUploadPhoto = false;
  private photo = "";
  private passportPhoto = "";
  private facePhoto = "";

  private modalFaceDetector = false;
  private validatePassportModal = false;

  private constraints = {
    audio: false,
    video: { width: 200, height: 250 },
  };

  $t: any;
  video: any;
  $router: any;

  toJpeg(src: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        const canvas = document.createElement("canvas") as HTMLCanvasElement;
        canvas.width = width;
        canvas.height = height;
        let context = canvas.getContext("2d")!;
        context.fillStyle = "#fff";
        context.fillRect(0, 0, width, height);
        context.drawImage(img, 0, 0);
        const base64 = canvas.toDataURL("image/jpeg");
        resolve(base64);
      };
      img.onerror = (err) => reject(err);

      img.src = src;
    });
  }

  toBase64(file: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async () => {
        let src = reader.result as string;
        let base64 = await this.toJpeg(src);
        resolve(base64);
      };
      reader.onerror = (err) => reject(err);

      reader.readAsDataURL(file);
    });
  }

  deleteProfilePic() {
    this.profilePicName = "";
    this.profilePicBase64 = "";
  }

  deletePassportPic() {
    this.passportPicName = "";
    this.passportPicBase64 = "";
  }

  deleteCedulaPic() {
    this.cedulaPicName = "";
    this.cedulaPicBase64 = "";
  }

  async profilePic(event: Event) {
    let files = (event.target as HTMLInputElement).files;
    if (files !== null && files.length > 0) {
      let file = files.item(0);
      if (file !== null) {
        this.profilePicName = file.name;
        try {
          this.profilePicBase64 = await this.toBase64(file);
        } catch (err) {
          window.console.log(err);
          this.deleteProfilePic();
        }
        return;
      }
    }

    this.deleteProfilePic();
  }

  async cedulaPic(event: Event) {
    let files = (event.target as HTMLInputElement).files;
    if (files !== null && files.length > 0) {
      let file = files.item(0);
      if (file !== null) {
        this.cedulaPicName = file.name;
        try {
          this.cedulaPicBase64 = await this.toBase64(file);
        } catch (err) {
          window.console.log(err);
          this.deleteCedulaPic();
        }
        return;
      }
    }

    this.deleteCedulaPic();
  }

  async passportPic(event: Event) {
    this.modalFaceDetector = false;
    let files = (event.target as HTMLInputElement).files;
    if (files !== null && files.length > 0) {
      let file = files.item(0);
      if (file !== null) {
        this.passportPicName = file.name;
        try {
          this.passportPicBase64 = await this.toBase64(file);
          this.passportPhoto = this.passportPicBase64;
          this.modalFaceDetector = true;
        } catch (err) {
          window.console.log(err);
          this.deletePassportPic();
        }
        return;
      }
    }

    this.deletePassportPic();
  }

  previous() {
    this.step--;
  }

  selectedPrefix(prefix: string) {
    this.phonePrefix = prefix;
  }

  errorMessages(data: any): Array<string> {
    let result = new Array<string>();
    if (data["Password"] !== undefined) {
      const passErrors = data["Password"];
      for (let i = 0; i < passErrors.length; ++i) {
        const passError = passErrors[i];
        if (passError["errorCode"] === "not_contains_number") {
          result.push("La contraseña debe tener algún caracter numérico.");
        } else if (passError["errorCode"] === "short_password") {
          result.push("La contraseña debe tener como mínimo 6 carácteres.");
        } else if (passError["errorCode"] === "not_contains_uppercase") {
          result.push("La contraseña debe tener algúna letra mayúscula.");
        } else if (passError["errorCode"] === "not_contains_lowercase") {
          result.push("La contraseña debe tener algúna letra minúscula.");
        } else if (passError["errorCode"] === "invalid_birthdate") {
          result.push("Fecha invalida.");
        }
      }
    }

    if (data["Pin"]) {
      result.push(
        "El PIN debe estar compuesto únicamente por 4 carácteres numéricos."
      );
    }

    if (data["BirthDate"]) {
      const passErrors = data["BirthDate"];
      for (let i = 0; i < passErrors.length; ++i) {
        const passError = passErrors[i];
        if (passError["errorCode"] === "invalid_birthdate") {
          result.push("Fecha de nacimiento no válida, debe ser mayor de edad.");
        }
      }
    }

    if (data["GivenName"]) {
      result.push("Nombre no válido");
    }

    if (data["FamilyName"]) {
      result.push("Apellido no válido");
    }

    return result;
  }

  showError(error: string) {
    this.errorMessage = error;
    this.isErrorMessageShow = true;
    setTimeout(() => (this.isErrorMessageShow = false), 8000);
  }

  async nextIdentification() {
    this.isIdentificationLoading = true;

    if (this.nationality === "") {
      this.showError("Rellene los campos obligatorios.");
      this.showNationalityRequiredError = true;
      this.isIdentificationLoading = false;
      return;
    }

    if (this.idDocumentType === "") {
      this.showError("Rellene los campos obligatorios.");
      this.showIdentificationRequiredError = true;
      this.isIdentificationLoading = false;
      return;
    }

    if (this.idDocumentType === "Passport") {
      this.step = 2;
      this.isIdentificationLoading = false;
      return;
    }

    try {
      const data = new ValidateDocumentationQuery(
        this.idDocumentType,
        this.idDocumentNumber
      );
      this.trivial = await accountApi.validateDocumentation(data);
      this.step = 2;
    } catch (err) {
      if (err?.response?.status === 404 && err.response.data?.errors[0]) {
        this.showError(this.$t(`errors.${err.response.data?.errors[0]}`));
      } else if (err.response.status === 400 && err.response.data) {
        this.showError(err.response.data);
      } else {
        this.showError(
          "Ha surgido algún error durante la validación los datos. Intentelo de nuevo más tarde."
        );
      }
    } finally {
      this.isIdentificationLoading = false;
    }
  }

  nextWithoutValidatePassport() {
    if (this.idDocumentType === "Passport") {
      this.passportPhoto = "";
      this.passportPicBase64 = "";
      this.facePhoto = "";
      this.profilePicBase64 = "";
      this.isCapture = false;
      this.isUploadPhoto = false;
      this.photo = "";
      this.validatePassportModal = false;
      this.isErrorMessageShow = false;
      this.step++;
    }
  }

  async nextValidation() {
    this.isValidationLoading = true;
    this.validationByCedula = false;

    if (this.idDocumentType === "Passport") {
      if (
        this.idDocumentNumber === "123456789" ||
        this.idDocumentNumber === "aabbccdd" ||
        this.idDocumentNumber === "ffgghhjj"
      ) {
        if (this.passportPhoto === "" || this.facePhoto === "") {
          this.showError("La foto del pasaporte y rostro son obligatorios.");
          this.isValidationLoading = false;
          return;
        }

        try {
          const data = new ValidatePassportCommand(
            this.idDocumentNumber,
            this.passportPhoto,
            this.facePhoto
          );

          const response = await accountApi.validatePassport(data);

          if (response.idCard === this.idDocumentNumber) {
            this.givenName = `${response.fistName} ${response.secondName}`;
            this.familyName = `${response.paternalSurname} ${response.maternalSurname}`;
            this.birthDate = response.birthDate;
            this.step++;
          } else {
            this.showError("Los datos no son válidos.");
            this.validatePassportModal = true;
          }
        } catch (err) {
          if (err?.response?.status === 404 && err.response.data?.errors[0]) {
            this.showError(this.$t(`errors.${err.response.data?.errors[0]}`));
          } else if (err.response.status === 400 && err.response.data) {
            this.showError(err.response.data);
          } else {
            this.showError(
              "Ha surgido algún error durante la validación los datos. Intentelo de nuevo más tarde."
            );
          }
        } finally {
          this.isValidationLoading = false;
        }
      } else {
        this.nextWithoutValidatePassport();
      }
      return;
    }

    /* Cedula */
    if (
      this.questionAnswersOne === "" ||
      this.questionAnswersThree === "" ||
      this.questionAnswersFour === "" ||
      this.questionAnswersTwo === ""
    ) {
      this.showError("Rellene los campos obligatorios.");
      this.isValidationLoading = false;
      return;
    }

    try {
      const questionAnswersOne = {
        question: this.trivial.questionAnswersOne.question,
        answer: this.questionAnswersOne,
      };
      const questionAnswersTwo = {
        question: this.trivial.questionAnswersTwo.question,
        answer: this.questionAnswersTwo,
      };
      const questionAnswersThree = {
        question: this.trivial.questionAnswersThree.question,
        answer: this.questionAnswersThree,
      };
      const questionAnswersFour = {
        question: this.trivial.questionAnswersFour.question,
        answer: this.questionAnswersFour,
      };

      const data = new ValidateCitizenCommand(
        this.idDocumentNumber,
        questionAnswersOne,
        questionAnswersTwo,
        questionAnswersThree,
        questionAnswersFour
      );

      const response = await accountApi.validateCitizen(data);

      if (response.idCard === this.idDocumentNumber) {
        this.givenName = `${response.fistName} ${response.secondName}`;
        this.familyName = `${response.paternalSurname} ${response.maternalSurname}`;
        this.birthDate = response.birthDate;
        this.keyValid = response.validKey;
        this.step++;
        this.validationByCedula = true;
      } else {
        this.trivial = await accountApi.validateDocumentation(
          new ValidateDocumentationQuery(
            this.idDocumentType,
            this.idDocumentNumber
          )
        );
        this.showError("Los datos no son válidos.");
      }
    } catch (err) {
      if (err?.response?.status === 404 && err.response.data?.errors[0]) {
        this.showError(this.$t(`errors.${err.response.data?.errors[0]}`));
      } else if (err.response.status === 400 && err.response.data) {
        this.showError(err.response.data);
      } else {
        this.showError(
          "Ha surgido algún error durante la validación los datos. Intentelo de nuevo más tarde."
        );
      }
    } finally {
      this.isValidationLoading = false;
    }
  }

  async nextPersonalInfo() {
    this.isPersonalInfoFirstAttempt = true;
    this.isPersonalInfoLoading = true;
    if (
      this.givenName === "" ||
      this.familyName === "" ||
      this.birthDate === "" ||
      this.address === "" ||
      this.email === "" ||
      (!this.sameEmailForNotifications && this.notificationsEmail === "") ||
      this.phonePrefix === "" ||
      this.phoneNumber === "" ||
      this.password === "" ||
      this.repeatPassword === "" ||
      this.pin === "" ||
      this.repeatPin === ""
    ) {
      this.showError("Rellene los campos obligatorios.");
      this.showPersonalInfoRequiredError = true;
      this.isPersonalInfoLoading = false;
      return;
    }

    if (this.password !== this.repeatPassword) {
      this.showError("Las contraseñas deben coincidir");
      this.isPersonalInfoLoading = false;
      return;
    }

    if (this.pin !== this.repeatPin) {
      this.showError("Los PIN deben coincidir");
      this.isPersonalInfoLoading = false;
      return;
    }

    const notificationsEmail = this.sameEmailForNotifications
      ? this.email
      : this.notificationsEmail;
    const cedula =
      this.idDocumentType === "Cedula" ? this.idDocumentNumber : "";
    const passport =
      this.idDocumentType === "Passport" ? this.idDocumentNumber : "";
    const data = new RegisterCommand(
      this.nationality,
      cedula,
      passport,
      this.givenName,
      this.familyName,
      this.birthDate,
      notificationsEmail,
      this.email,
      this.address,
      this.phonePrefix,
      this.phoneNumber,
      this.password,
      this.repeatPassword,
      this.pin,
      this.repeatPin,
      this.profilePicBase64?.split("base64,")[1] ?? "",
      this.cedulaPicBase64?.split("base64,")[1] ?? "",
      this.passportPicBase64?.split("base64,")[1] ?? "",
      this.keyValid
    );

    try {
      await accountApi.register(data);
      this.step = 4;
    } catch (err) {
      console.log(err.response);
      const errorMessages =
        err?.response?.data !== undefined
          ? this.errorMessages(err.response.data)
          : [];

      if (errorMessages.length > 0) {
        window.console.log(errorMessages);
        let message = "Corrija los siguientes errores: <ul>";
        errorMessages.forEach((m) => (message += `<li>${m}</li>`));
        message += "</ul>";
        this.showError(message);
      } else if (err.response.status === 400 && err.response.data) {
        this.showError(err.response.data);
      } else {
        this.showError("Ha habido algún error. Intentelo de nuevo más tarde.");
      }
    } finally {
      this.isPersonalInfoLoading = false;
    }
  }

  async eventCamera(isCapture: any) {
    this.isCapture = isCapture;
    this.deletePassportPic();
    this.isUploadPhoto = false;

    let n = navigator.mediaDevices;

    if (n.getUserMedia) {
      n.getUserMedia(this.constraints)
        .then((stream: any) => {
          const video = document.getElementById(
            "video-passport"
          ) as HTMLVideoElement;

          if (video) {
            video.srcObject = stream;
            video.onloadedmetadata = function () {
              video.play();
            };
            this.video = video;
            this.passportPhoto = "";
          }

          if (!this.isCapture) {
            stream.getTracks().forEach(function (track: any) {
              track.stop();
            });

            if (this.video) {
              this.video.srcObject.getTracks().forEach(function (track: any) {
                track.stop();
              });

              this.video.srcObject = null;
            }
          }
        })
        .catch((err: any) => {
          console.log(err);
          alert("The following error occurred: " + err.name);
        });
    } else {
      alert("getUserMedia not supported");
    }
  }

  async capturePhoto() {
    this.photo = "";
    const canvas = this.$refs.canvaspassport as HTMLCanvasElement;
    var context = canvas.getContext("2d")!;
    context.drawImage(this.video, 0, 0, 200, 250);
    this.photo = canvas.toDataURL("image/jpeg");
    this.passportPhoto = this.photo;
    this.modalFaceDetector = true;
    this.eventCamera(false);
  }

  async uploadPhoto() {
    if (this.isCapture) {
      this.eventCamera(false);
    }
    this.photo = "";
    this.passportPhoto = "";
    this.isUploadPhoto = true;
    this.modalFaceDetector = false;
  }

  photoTaken(isPhotoTaken: any, image: any) {
    this.stopCameraStream();
    this.modalFaceDetector = !isPhotoTaken;
    this.facePhoto = image;
    this.profilePicBase64 = image;
  }

  backRegister() {
    this.stopCameraStream();

    let url = this.$router.resolve({
      name: "Register",
    });

    window.location.href = url.href;
  }

  stopCameraStream() {
    try {
      const video = document.getElementById("video-face") as HTMLVideoElement;
      if (video) {
        video.pause();
        (video.srcObject as MediaStream)
          ?.getTracks()
          .forEach((stream) => stream.stop());
      }
    } catch (e) {
      console.log(e);
    }
  }
}
